// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"432":"93589c1f","574":"d5dd55f1"}[chunkId] + ".chunk.css";
};